import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-review-mgt',
  templateUrl: './review-mgt.component.html',
  styleUrls: ['./review-mgt.component.css']
})
export class ReviewMgtComponent implements OnInit {

  searchForm: FormGroup | any;
  // whichmodal: string = 'enable';
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  helplineId: any
  faqList: any = [];
  faqId: any;
  feedBackList: any = [];
  reviewId: any;

  constructor(private router: Router,
    public mainService: MainService) { }
  ngOnInit() {
    this.searchFormValidation();
    this.getFeedbackList(this.currentPage)
  }

  searchFormValidation() {
    this.searchForm = new FormGroup({
      search: new FormControl('')
    });
    this.searchForm.valueChanges.subscribe((res: any) => {
      let filter = this._filter(res.search);
      this.feedBackList = filter;
      if (res.search == '') {
        this.getFeedbackList(this.currentPage);
      }
    })
  }

  _filter(value: any): string[] {
    const filterValue = value.toLowerCase();
    return this.feedBackList.filter((option: any) => option.givenTo.firstName.toLowerCase().includes(filterValue));
  }

  searchFormSubmit() {
    if (this.searchForm.value.search) {
      // this.getFaqList()
    }
  }
  searchFormReset() {
    if (this.searchForm.value.search) {
      this.searchForm.reset();
      // this.getFaqList()
    }
  }

  pagination(event: any) {
    this.currentPage = event;
  }

  // ------- getFeedbackList list -------- //

  getFeedbackList(page: number) {
    this.currentPage = page;
    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.feedback_List + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.feedBackList = res.result ? res.result : [];
        this.total = res.paginationData.total;
        this.mainService.hideSpinner();
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.feedBackList = res.result ? res.result : []
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }


  viewReview(id: any) {
    this.router.navigate(['view-review/' + id])
  }

  deleteFaqModal(id: any) {
    this.reviewId = id
    $('#delete').modal('show')
  }

  deleteReview() {
    const data = {
      _id: this.reviewId,
      status: "DELETE"
    }
    this.mainService.showSpinner();
    this.mainService.postApi(ApiUrls.actionPerform_feedback, data, 1).subscribe((res: any) => {
      $('#delete').modal('hide')
      if (res.responseCode == 200) {
        this.feedBackList = res.result;
        this.getFeedbackList(this.currentPage)
        this.mainService.successToast(res.responseMessage);
        setTimeout(() => {
          this.mainService.hideSpinner();
        }, 1000);
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }
}
